import React, { useState } from 'react'
import { Grid, Button } from '@material-ui/core'
import { FormattedMessage, useIntl } from 'react-intl'
import { makeStyles, Theme } from '@material-ui/core/styles'
import messages from '../../messages'
import { biTubeConfigContext } from './BiTube'
import { fastDuplexOligosRoute, useRouter } from '@src/routes'
import {
  ActiveLinkType,
  Buttons,
  BiTubeProduct,
  BitubeProperties,
} from './enum'
import {
  useBiTubePriceCallMutation,
  useSessionFieldsMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import ViewAllDialog from './BitubeProductSummary/ViewAllDialog'
import CircleLoader from '@src/components/CircleLoader/CircleLoader'
import { ConfiguratorValues } from '../../utils/constants'

const useStyles = makeStyles((theme: Theme) => {
  return {
    buttonconfig: {
      width: theme.spacing(50),
      color: '#0783b8',
      borderColor: '#0783b8',
      fontWeight: theme.typography.fontWeightMedium,
    },
    configDefaultButton: {
      width: theme.spacing(50),
      fontWeight: theme.typography.fontWeightMedium,
    },
    continueButton: {
      width: theme.spacing(50),
      float: 'right',
      fontWeight: theme.typography.fontWeightMedium,
    },
  }
})
const SingleProductEntryButtons = (props) => {
  const classes = useStyles()
  const intl = useIntl()
  const maxItems = BitubeProperties.MaximumOligosAllowed
  const { bitubeState, biTubeDispatch } = React.useContext(biTubeConfigContext)
  const { sessionData, OligoIndex } = bitubeState
  const { productDetails, setActive, setItemDetails } = props
  const [biTubePriceCall, { loading: priceLoading }] =
    useBiTubePriceCallMutation()
  const [dialogOpen, setDialogOpen] = useState(false)
  const router = useRouter()
  const [sessionFields] = useSessionFieldsMutation()
  const sessionDataToSession = async (obj) => {
    await sessionFields({
      variables: { input: obj, productInput: productDetails },
    })
  }
  const emptyObj = {
    isOverridden: false,
    name: '',
    sequence: '',
    fiveMod: '',
    purification: '',
    baseCount: 0,
    format: '',
    concentration: '',
    tubes: '1',
    price: '',
    scale: '',
    orderItemId: '',
    id: '1',
    comments: '',
    additionalComments: '',
    oligoId: 1,
    countryCode: '',
    autoValidation: 'false',
    productType: '',
    customerOverhang: '',
    antisenceName: '',
    antisenceSequence: '',
    autoGenerateOligo: false,
    customerAntisenseOverHang: '',
    antisenceBaseCount: 0,
    amount: '',
    senseNameCheck: false,
    listError: [{ key: '', value: '' }],
  }
  const setErrorData = (index) => {
    return {
      name: sessionData[index].name,
      sequence: sessionData[index].sequence,
      scale: '',
      purification: sessionData[index].purification,
      fiveMod: '',
      threeMod: sessionData[index].threeMod,
      researcher: '',
      isOverridden: sessionData[index].isOverridden,
      format: sessionData[index].format,
      concentration: sessionData[index].concentration,
      tubes: sessionData[index].tubes,
      customerOverhang: sessionData[index].customerOverhang,
      antisenceName: sessionData[index].antisenceName,
      antisenceSequence: sessionData[index].antisenceSequence,
      customerAntisenseOverHang: sessionData[index].customerAntisenseOverHang,
      antisenceThreeMod: sessionData[index].antisenceThreeMod,
      antisenceFiveMod: sessionData[index].antisenceFiveMod,
      antisenceBaseCount: 0,
      amount: sessionData[index].amount,
      autoGenerateOligo: sessionData[index].autoGenerateOligo,
      senseNameCheck: sessionData[index].senseNameCheck,
    }
  }
  const nextStep = async () => {
    const response: any = await biTubePriceCall({
      variables: { product: productDetails },
    })
    if (response.data && !response.data.biTubePriceCall[0].serverError) {
      let flag = false
      //setting the response in itemDetails for GA
      setItemDetails(response.data.biTubePriceCall)
      response.data.biTubePriceCall.forEach((item, index) => {
        if (item.listErrors.length !== 0) {
          if (!flag) {
            if (bitubeState.currentOligoIndex !== index) {
              //if the current index changes pageReload should be set true
              biTubeDispatch({ type: 'IS_PAGE_RELOAD', data: true })
            }
            //set the current index to the 1st errored item
            biTubeDispatch({
              type: 'UPDATE_CURRENT_OLIGO_INDEX',
              data: index,
            })
            biTubeDispatch({
              type: 'UPDATE_ERROR_DATA',
              data: setErrorData(index),
            })
          }
          flag = true
          biTubeDispatch({ type: 'SET_PAGE_ERROR', data: '' })
        }
        const error: any[] = []
        item.listErrors.forEach((err) => {
          delete err.__typename
          error.push(err)
        })
        if (sessionData.length > index) {
          sessionData[index].listError = error
          sessionData[index].price = item.price
          sessionData[index].currencySymbol = item.currencySymbol
          sessionData[index].currency = item.currency
        }
        //update the circuit breaker warning if priceHeaderError in not null
        if (
          item.priceHeaderError !== null &&
          item.priceHeaderError.length !== 0
        ) {
          biTubeDispatch({ type: 'UPDATE_CIRCUIT_BREAK', data: true })
        } else {
          biTubeDispatch({ type: 'UPDATE_CIRCUIT_BREAK', data: false })
        }
      })

      if (!flag) {
        bitubeState.errorResponseJson.listErrors = []
        biTubeDispatch({ type: 'SET_STEP_NO', data: 1 })
        biTubeDispatch({ type: 'IS_BULK_REVIEW', data: false })
        biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: true })
        biTubeDispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: true })
        const url = `${fastDuplexOligosRoute.index()}?product=${
          productDetails.productType
        }&activeLink=${ActiveLinkType.ConfirmOrder}`
        router.push(url)
      } else {
        biTubeDispatch({
          type: 'SET_PAGE_ERROR',
          data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
        })
        biTubeDispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: false })
        biTubeDispatch({ type: 'SET_STEP_NO', data: 0 })
        biTubeDispatch({ type: 'OVERRIDDEN_NUMBER', data: 1 })
        window.scrollTo(0, 0)
      }
      biTubeDispatch({ type: 'SPECIFICATION_TOTAL_VALIDATION', data: true })
      biTubeDispatch({
        type: 'UPDATE_TOTALVALIDATION',
        data: response.data.biTubePriceCall,
      })
    } else {
      biTubeDispatch({
        type: 'SET_PAGE_ERROR',
        data: ConfiguratorValues.InternalServerError,
      })
      window.scrollTo(0, 0)
    }
  }
  const handleContinue = () => {
    //if the user clicks on continue after adding a new item and without configuring it,
    // then call total validation
    biTubeDispatch({ type: 'IS_VALID_TOTAL_VALIDATION', data: false })
    biTubeDispatch({ type: 'SET_ERROR_ICON_ON_PAGELOAD', data: false })
    if (bitubeState.noContinueToNextPage) {
      sessionDataToSession(sessionData)
      biTubeDispatch({
        type: 'SET_PAGE_ERROR',
        data: intl.formatMessage(messages.CONF_DNAPLATES_ERROR_STEP2),
      })
      biTubeDispatch({
        type: 'ITEM_VALIDATION',
        data: true,
      })
      biTubeDispatch({
        type: 'SET_CONTINUE_TO_NEXT_PAGE',
        data: false,
      })
      window.scrollTo(0, 0)
    } else {
      // else make price call, if all the items are configured
      nextStep()
    }
    biTubeDispatch({
      type: 'ON_CONTINUE_BUTTON_PRICECALL',
      data: true,
    })
    biTubeDispatch({
      type: 'VALIDATE_ON_CLICK',
      data: true,
    })
  }

  const performTubeDelete = (item, type) => {
    if (type === 'Selected' || type === 'SelectedViewAll') {
      if (OligoIndex !== 0) {
        const newIndex = OligoIndex - 1
        const array = [...bitubeState.sessionData]
        const index = array.indexOf(item)
        if (index !== -1) {
          sessionData.splice(index, 1)
        }
        biTubeDispatch({
          type: 'UPDATE_OLIGO_INDEX',
          data: newIndex,
        })
        biTubeDispatch({
          type: 'UPDATE_CURRENT_OLIGO_INDEX',
          data: newIndex,
        })
        biTubeDispatch({
          type: 'CALL_SESSION_API',
          data: true,
        })
        biTubeDispatch({
          type: 'UPDATE_INPUT',
          data: [...bitubeState.sessionData],
        })
        biTubeDispatch({
          type: 'UPDATE_ERROR_DATA',
          data: setErrorData(newIndex),
        })
      } else {
        bitubeState.oligoCount = 0
        biTubeDispatch({
          type: 'SET_CONTINUE_TO_NEXT_PAGE',
          data: true,
        })
        biTubeDispatch({
          type: 'UPDATE_OLIGO_INDEX',
          data: 0,
        })
        biTubeDispatch({
          type: 'UPDATE_CURRENT_OLIGO_INDEX',
          data: 0,
        })
        biTubeDispatch({
          type: 'UPDATE_ERROR_DATA',
          data: {
            ...bitubeState.errorData,
            name: '',
            sequence: '',
            scale: '',
            purification: '',
            fiveMod: '',
            threeMod: '',
            researcher: '',
            format: '',
            concentration: '',
            isOverridden: false,
            tubes: '1',
            antisenceName: '',
            antisenceSequence: '',
          },
        })
        biTubeDispatch({ type: 'OVERRIDDEN_NUMBER', data: 0 })
        biTubeDispatch({
          type: 'CALL_SESSION_API',
          data: true,
        })
        biTubeDispatch({
          type: 'UPDATE_INPUT',
          data: [emptyObj],
        })
        biTubeDispatch({
          type: 'DELETE_LAST_OLIGO',
          data: bitubeState.deleteLastOligo + 1,
        })
        biTubeDispatch({ type: 'SPECIFICATION_TOTAL_VALIDATION', data: false })
        biTubeDispatch({ type: 'IS_DELETE_ALL', data: true })
        biTubeDispatch({ type: 'CLEAR_SESSION_DATA', data: true })
        setDialogOpen(false)
      }
    } else if (type === 'All') {
      sessionData[0].applyToAll = false
      bitubeState.oligoCount = 0
      biTubeDispatch({
        type: 'SET_CONTINUE_TO_NEXT_PAGE',
        data: true,
      })
      biTubeDispatch({
        type: 'UPDATE_OLIGO_INDEX',
        data: 0,
      })
      biTubeDispatch({
        type: 'UPDATE_CURRENT_OLIGO_INDEX',
        data: 0,
      })
      biTubeDispatch({
        type: 'UPDATE_ERROR_DATA',
        data: {
          ...bitubeState.errorData,
          name: '',
          sequence: '',
          scale: '',
          purification: '',
          fiveMod: '',
          threeMod: '',
          researcher: '',
          format: '',
          concentration: '',
          isOverridden: false,
          tubes: '1',
        },
      })
      biTubeDispatch({ type: 'OVERRIDDEN_NUMBER', data: 0 })
      biTubeDispatch({
        type: 'CALL_SESSION_API',
        data: true,
      })
      biTubeDispatch({
        type: 'UPDATE_INPUT',
        data: [emptyObj],
      })
      biTubeDispatch({
        type: 'IS_PAGE_RELOAD',
        data: true,
      })
      biTubeDispatch({ type: 'CLEAR_SESSION_DATA', data: true })
      biTubeDispatch({
        type: 'DELETE_LAST_OLIGO',
        data: bitubeState.deleteLastOligo + 1,
      })
      biTubeDispatch({ type: 'SPECIFICATION_TOTAL_VALIDATION', data: false })
      setDialogOpen(false)
      window.scrollTo(0, 0)
      biTubeDispatch({ type: 'IS_DELETE_ALL', data: true })
    }
    biTubeDispatch({
      type: 'UPDATE_PAGE_LOAD',
      data: 1,
    })
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 10)
  }
  const addOligo = () => {
    if (sessionData.length < BitubeProperties.MaximumOligosAllowed) {
      //Please correct error(s) before adding a new item
      biTubeDispatch({
        type: 'ADD_NEW_DUPLEX',
        data: true,
      })
      biTubeDispatch({ type: 'CALL_TOTAL_VALIDATION', data: true })
      biTubeDispatch({
        type: 'UPDATE_PAGE_LOAD',
        data: 1,
      })
      biTubeDispatch({ type: 'IS_CONFIRM_ORDER', data: false })
      biTubeDispatch({
        type: 'VALIDATE_ON_CLICK',
        data: true,
      })
    } else {
      biTubeDispatch({
        type: 'SET_PAGE_ERROR',
        data: intl.formatMessage(messages.CONF_MAX_ITEMS_ALLOWED, { maxItems }),
      })
      window.scrollTo(0, 0)
    }
  }
  // This method is use to perform delete and delete all operations
  const deleteOligoItem = (item, type) => {
    performTubeDelete(item, type)
  }
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={3}>
          <Button
            variant="contained"
            size="large"
            color="primary"
            onClick={addOligo}
            className={classes.configDefaultButton}
            id="add-duplex-button"
            data-testid="add-duplex-button"
          >
            {productDetails.productType === BiTubeProduct.LightCycler ? (
              <FormattedMessage {...messages.CONF_ADD_OLIGO_SIDE_BAR} />
            ) : (
              <FormattedMessage {...messages.CONF_ADD_DUPLEX_SIDE_BAR} />
            )}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            variant="outlined"
            size="large"
            color="primary"
            className={classes.buttonconfig}
            onClick={() => {
              biTubeDispatch({
                type: 'ITEM_VALIDATION',
                data: true,
              })
              setDialogOpen(true)
            }}
            id="view-duplex-button"
            data-testid="view-duplex-button"
          >
            {productDetails.productType === BiTubeProduct.LightCycler
              ? Buttons.ViewOligo
              : Buttons.ViewDuplex}
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Button
            color="primary"
            variant="contained"
            size="large"
            onClick={handleContinue}
            className={classes.continueButton}
            id="duplex-continue-button"
            data-testid="duplex-continue-button"
          >
            <FormattedMessage {...messages.CONF_AQUA_CONTINUE_BUTTON} />
          </Button>
        </Grid>
      </Grid>
      <ViewAllDialog
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        viewAllItems={sessionData}
        setActive={setActive}
        onDelete={deleteOligoItem}
        productName={productDetails.productType}
      />
      {priceLoading && <CircleLoader />}
    </>
  )
}

export default SingleProductEntryButtons
